import { LOCATION_CHANGE } from "connected-react-router";
import { cloneObject } from "@utils/object";
import {
  // Client
  GetClient,
  GetClientSuccess,
  GetClientError,
  // Client list
  GetClients,
  GetClientsSuccess,
  GetClientsError,
  GetClientsCsv,
  SetClientsSort,
  GetClientsCsvSuccess,
  GetClientsCsvError,
  GetClientsSchema,
  SetClientsSchema,
  UpdateClientDetails,
  UpdateClientDetailsError,
  UpdateClientDetailsSuccess,
  ToggleAddClientModal,
  SetAdminAccountsAddModal,
  AddClientDetails,
  AddClientDetailsSuccess,
  AddClientDetailsError,
  // Client service
  GetClientServiceError,
  GetClientServiceSuccess,
  SetClientServiceSchema,
  DismissAddNewService,
  AddNewServiceError,
  UpdateServiceAbsenceManagementSettings,
  GetServiceAbsenceManagementSettings,
  // Client admin
  // SLA
  GetAgreements,
  GetAgreementsSuccess,
  GetAgreementsError,
  PutAgreements,
  PutAgreementsSuccess,
  PutAgreementsError,
  ToggleSlaClientModal,
  GetSlaSchema,
  GetSlaSchemaSuccess,
  GetSlaSchemaError,
  //Self Service Requests
  ToggleSelfServiceModal,
  // SLA Performance
  UpdateSlaPerformanceSectionsToggle,
  UpdateSlaPerformanceScopeAndFilters,
  ResetSlaPerformanceScopeAndFilters,
  GetSlaPerformanceReportDetails,
  GetSlaPerformanceReportDetailsSuccess,
  GetSlaPerformanceReportDetailsError,
  ExportSlaPerformanceReport,
  ExportSlaPerformanceReportSuccess,
  ExportSlaPerformanceReportError,
  GetAllClientsListSuccess,
} from "@modules/client/constants/actions";
import admin from "./admin/state";
import client from "./client/state";
import service from "./service/state";
import agreements from "./sla/state";
import slaPerformance from "./sla-performance/state";
import * as clientReducers from "./client/reducers";
import * as serviceReducers from "./service/reducers";
import * as SlaReducers from "./sla/reducers";
import * as SlaPerformanceReducers from "./sla-performance/reducers";

export const initialState = Object.assign(
  {
    error: null,
  },
  {
    admin,
    agreements,
    slaPerformance,
    client,
    service,
    list: {
      content: [],
      pagination: null,
      totalElements: 0,
    },
  },
);

const onLocationChange = state => () => {
  return {
    ...state,
    admin: {
      ...state.admin,
      modals: {
        ...state.admin.modals,
        createAdmin: {
          ...state.admin.modals.createAdmin,
          admin: null,
        },
        enable: {
          ...state.admin.modals.enable,
          employee: null,
        },
        disable: {
          ...state.admin.modals.disable,
          admin: null,
        },
      },
    },
  };
};
export const onGetAllClientsListSuccess = state => ({ payload }: Object) => {
  return {
    ...state,
    list: payload,
  };
};

export default (state = initialState, action) => {
  const act = {
    [GetClient]: clientReducers.onGetClient,
    [GetClientSuccess]: clientReducers.onGetClientSuccess,
    [GetClientError]: clientReducers.onGetClientError,
    // Client list
    [GetClients]: clientReducers.setLoading,
    [GetClientsSchema]: clientReducers.setLoading,
    [GetClientsSuccess]: clientReducers.onGetClientsSuccess,
    [GetClientsError]: clientReducers.onGetClientsError,
    [SetClientsSchema]: clientReducers.onSetClientsSchema,
    [GetClientsCsv]: clientReducers.onGetClientsCsv,
    [SetClientsSort]: clientReducers.onSetClientsSort,
    [GetClientsCsvSuccess]: clientReducers.onGetClientsCsvSuccess,
    [GetClientsCsvError]: clientReducers.onGetClientsCsvError,
    [UpdateClientDetails]: clientReducers.onUpdateClientDetails,
    [UpdateClientDetailsError]: clientReducers.onUpdateClientDetailsError,
    [UpdateClientDetailsSuccess]: clientReducers.onUpdateClientDetailsSuccess,
    [ToggleAddClientModal]: clientReducers.onToggleAddClientModal,
    [SetAdminAccountsAddModal]: clientReducers.onToggleAddAdminAccountModal,
    [ToggleSelfServiceModal]: clientReducers.onToggleSelfServiceModal,
    [AddClientDetails]: clientReducers.onAddClientDetails,
    [AddClientDetailsSuccess]: clientReducers.onAddClientDetailsSuccess,
    [AddClientDetailsError]: clientReducers.onAddClientDetailsError,
    // Client service
    [GetServiceAbsenceManagementSettings]: serviceReducers.setLoading,
    [GetClientServiceSuccess]: serviceReducers.onGetClientServiceSuccess,
    [GetClientServiceError]: serviceReducers.onGetClientServiceError,
    [SetClientServiceSchema]: serviceReducers.onSetClientServiceSchema,
    [DismissAddNewService]: serviceReducers.onDismissAddNewService,
    [AddNewServiceError]: serviceReducers.onAddNewServiceError,
    [UpdateServiceAbsenceManagementSettings]: serviceReducers.setLoading,

    [LOCATION_CHANGE]: onLocationChange,
    // SLA
    [GetAgreements]: SlaReducers.setLoading,
    [GetAgreementsSuccess]: SlaReducers.onGetAgreementsSuccess,
    [GetAgreementsError]: SlaReducers.onGetAgreementsError,
    [PutAgreements]: SlaReducers.setLoading,
    [PutAgreementsSuccess]: SlaReducers.onPutAgreementsSuccess,
    [PutAgreementsError]: SlaReducers.onPutAgreementsError,
    [ToggleSlaClientModal]: SlaReducers.onToggleSlaClientModal,
    [GetSlaSchema]: SlaReducers.setLoading,
    [GetSlaSchemaSuccess]: SlaReducers.onGetSlaSchemaSuccess,
    [GetSlaSchemaError]: SlaReducers.onGetSlaSchemaError,
    // SLA Performance
    [UpdateSlaPerformanceSectionsToggle]:
      SlaPerformanceReducers.onUpdateSlaPerformanceSectionsToggle,
    [UpdateSlaPerformanceScopeAndFilters]:
      SlaPerformanceReducers.onUpdateSlaPerformanceScopeAndFilters,
    [ResetSlaPerformanceScopeAndFilters]:
      SlaPerformanceReducers.onResetSlaPerformanceScopeAndFilters,
    [GetSlaPerformanceReportDetailsSuccess]:
      SlaPerformanceReducers.onGetSlaPerformanceReportDetailsSuccess,
    [GetSlaPerformanceReportDetailsError]:
      SlaPerformanceReducers.onGetSlaPerformanceReportDetailsError,
    [GetSlaPerformanceReportDetails]: SlaPerformanceReducers.onGetSlaPerformanceReportDetails,
    [ExportSlaPerformanceReport]: SlaPerformanceReducers.onExportSlaPerformanceReport,
    [ExportSlaPerformanceReportSuccess]: SlaPerformanceReducers.onExportSlaPerformanceReportSuccess,
    [ExportSlaPerformanceReportError]: SlaPerformanceReducers.onExportSlaPerformanceReportError,
    [GetAllClientsListSuccess]: onGetAllClientsListSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
